<template>
  <div class="card">
    <div class="header" @click="show_block()">
      <div class="title">
        {{translate("speed.speed")}}
        <span>
          ( {{ hide_block ? translate('click_to_hide') : translate('click_to_show') }} )
        </span>
      </div>
    </div>
    <div class="content" :class="{hide_block: !hide_block}" v-on:wheel="wheel">
      <div class="toggle_button">
        <span :class="{ chosen : cur_type=='max'}" @click="cur_type='max'">{{translate("speed.max")}}</span>
        <span :class="{ chosen : cur_type=='middle'}" @click="cur_type='middle'" > {{translate("speed.middle")}}</span>
        <span :class="{ chosen : cur_type=='traffic'}" @click="cur_type='traffic'" > {{translate("speed.traffic")}}</span>
      </div>
      <div class="numbers left" />
      <div class="spinner_charts" style="padding-top: 15%" v-if="load">
        <scale-loader style="position: relative; padding-top: 9%" />
      </div>

      <div class="echarts" v-if='show_content'>
        <IEcharts
          :option="option"
          @ready="onReady"
        />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ChartChart',
  props: ['main_data', 'show_content', 'hide_block', 'today'],

  data () {
    // const that = this
    return {
      ins: null,
      echarts: null,
      load: true,
      show: false,
      data: [],
      cur_type: 'middle'
    }
  },

  computed: {
    info(){
      return this.main_data
    },
    loader(){
      return this.status
    },
    time () {
      return this.info.time.map(this.translate_of_time)
    },
    legend_data () {
      let legend = []
      for (let i in this.info.sim) {
        legend.push(i)
      }
      return legend
    },

    option () {
      return {
        toolbox: {
            show: true,
            feature: {
              saveAsImage: {
                title: this.translate('save'),
                type: 'png',
                pixelRatio: 5
              }
            }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          },
          formatter: function (series) {
            let axisIndex0 = 'download:<br/>'
            let axisIndex1 = 'upload:<br/>'
            let template = series[0].name + '<br/>'
            for (let i in series) {
              if (series[i].axisIndex === 1) {
                axisIndex1 += series[i].marker + this.info.sim[series[i].seriesName].mno + ((this.info.sim[series[i].seriesName].slot !== undefined) ? '(' + this.info.sim[series[i].seriesName].slot + ')' : '') + ':' + (series[i].value ? series[i].value : 0) + '<br/>'
              } else if (series[i].axisIndex === 0) {
                axisIndex0 += series[i].marker + this.info.sim[series[i].seriesName].mno + ((this.info.sim[series[i].seriesName].slot !== undefined) ? '(' + this.info.sim[series[i].seriesName].slot + ')' : '') + ':' + (series[i].value ? series[i].value : 0) + '<br/>'
              }
            }
            template += axisIndex0 + axisIndex1
            return template
          }.bind(this)
        },
        legend: {
          type: 'scroll',
          itemGap: 8,
          itemHeight: 10,
          y: 30,
          // data: this.legend_data,
          formatter: function (imsi) {
            return this.info.sim[imsi].mno + ((this.info.sim[imsi].slot !== undefined && this.info.sim[imsi].slot !== null) ? '(' + this.info.sim[imsi].slot + ')' : '')
          }.bind(this),
          left: 'right'
        },
        axisPointer: {
          link: {xAxisIndex: 'all'}
        },
        dataZoom: [
          {
            bottom: '1%',
            show: true,
            realtime: false,
            start: 0,
            end: 100,
            xAxisIndex: [0, 1],
            zoomOnMouseWheel: 'shift',
            type: 'slider'
          }
        ],
        grid: [{
          y: '15%',
          left: 90,
          right: 35,
          height: '34%'
        }, {
          left: 90,
          right: 35,
          top: '57%',
          height: '34%'
        }],
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLine: {onZero: true},
            data: this.time
          },
          {
            gridIndex: 1,
            type: 'category',
            boundaryGap: false,
            axisLine: {onZero: true},
            data: this.time
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            name: this.translate('speed.down') + '(' + (((this.cur_type!=='traffic'))?this.translate('speed.Mbs') : this.translate('speed.MB'))  + ')',
            type: 'value'
          },
          {
            gridIndex: 1,
            name: this.translate('speed.up') + '(' + (((this.cur_type!=='traffic'))?this.translate('speed.Mbs') : this.translate('speed.MB')) + ')',
            type: 'value'
          }
        ],
        series: this.data
      }
    }
  },
  watch: {

    cur_type () {
      this.load = true
      this.show = false
      setTimeout( () => { this.data = this.setSeries(); this.show = true }, 100)
    },
    resize () {
      if (this.ins !== undefined) {
        this.ins.resize()
      }
    },

    info () {
      if (Object.keys(this.info).length !== 0) {
        this.show = true
      } else {
        this.show = false
      }
    }

  },
  methods: {
    translate_of_time(unixTime){
      let options = {}
      if (this.today) {
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit'
        }
      }else{
        options = {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          day: '2-digit',
          month: '2-digit'
        }
      }
      return this.get_date(unixTime, options)
    },
    show_block(){
      this.$emit('hide_speed')
    },
    wheel (event) {
      if (event.shiftKey) {

        let start = this.ins.getOption().dataZoom[0].start + event.zrDelta * 2
        let end = this.ins.getOption().dataZoom[0].end - event.zrDelta * 2
        if(start < 0 || end > 100 || start > end || end < start || (end - start <= 0) ) {
          return false
        }
        this.ins.dispatchAction({
          type: 'dataZoom',
          start: start,
          end: end,
        })
      }
    },

    setSeries() {
      let series = []
      let temp = {}
      for (let i in this.legend_data) {
        temp = {
          name: this.legend_data[i],
          type: (this.cur_type!=='traffic')?'line' : 'bar',
          symbolSize: 8,
          hoverAnimation: false
        }

        temp.data = this.info.download[this.cur_type][this.legend_data[i]]
        temp.xAxisIndex = 0
        temp.yAxisIndex = 0
        series.push(temp)
        temp = {...temp}
        temp.data = this.info.upload[this.cur_type][this.legend_data[i]]
        temp.xAxisIndex = 1
        temp.yAxisIndex = 1

        series.push(temp)
      }
      return series
    },

    onReady (instance, echarts) {
      const that = this
      that.ins = instance
      that.echarts = echarts
      that.timer = null
      this.load = true;

      setTimeout( () => { this.data = this.setSeries(); this.show = true }, 200)
      that.ins.on('finished',() => { if(this.show == true) { this.load = false; this.$emit('finished',1) }})

      const updatePosition = function () {
        clearTimeout(that.timer)

        that.timer = setTimeout(() => {
          if (that.ins.resize !== undefined || that.ins.resize !== null) {
            that.ins.resize()
          }
        }, 250)
      }
      window.addEventListener('resize', updatePosition)
    }
  }
}
</script>
<style lang="scss" scoped>
  .card{
    padding: 10px;
    overflow: hidden;
    .header{
      padding: 10px 0;
      z-index: 2;
      cursor: pointer;
      .title{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span{
          color: #999;
          font-size: 14px;
          font-weight: 600;
          margin-left: 5px;
        }
      }
    }
    .content{
      transition: 0.3s;
      opacity: 1;
      height: auto;
      z-index: 1;
      &.hide_block{
        opacity: 0;
        height: 0;
        padding: 0;
        z-index: 0;
      }
      .toggle_button{
        z-index: 10;
        margin-bottom: 20px;
      }
      .echarts {
        width: 99%;
        height: 690px;
        margin-top: -40px;
        margin-bottom: -12px;
      }
    }
  }
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

</style>
